export default __webpack_public_path__ + "static/media/logo-transferencia.65b36261.png";